import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Badge } from './ui/badge';
import { User, Plus } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Reusable TeamMember/Team Selector
 * Used across: ScheduleTab, CalendarScheduler, AssetsTab
 */
const TeamMemberSelector = ({ 
  teamMembers = [], 
  value, 
  onChange, 
  placeholder = "Select teamMember...",
  showUnassign = true,
  showAddButton = false,
  onAddClick,
  disabled = false,
  showRoleBadge = false,
  filterByRole = null,
  className = ""
}) => {
  const filteredTeamMembers = filterByRole 
    ? teamMembers.filter(c => c.roleId === filterByRole)
    : teamMembers;

  return (
    <div className="flex gap-2">
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {showUnassign && (
            <SelectItem value="none">
              <span className="text-gray-500 italic">Unassign</span>
            </SelectItem>
          )}
          {filteredTeamMembers.length === 0 ? (
            <div className="px-2 py-4 text-sm text-gray-500 text-center">
              No teamMembers available
            </div>
          ) : (
            filteredTeamMembers.map((teamMember) => (
              <SelectItem key={teamMember.id} value={teamMember.id}>
                <div className="flex items-center gap-2">
                  <User className="w-3 h-3 text-gray-400" />
                  <span>{teamMember.name}</span>
                  {showRoleBadge && teamMember.roleName && (
                    <Badge variant="outline" className="text-xs">
                      {teamMember.roleName}
                    </Badge>
                  )}
                </div>
              </SelectItem>
            ))
          )}
          {showAddButton && (
            <SelectItem 
              value="__add_new__" 
              className="text-blue-600 font-semibold border-t mt-1 pt-2"
            >
              ➕ Add TeamMember
            </SelectItem>
          )}
        </SelectContent>
      </Select>
      {showAddButton && onAddClick && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onAddClick}
          className="flex-shrink-0"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add
        </Button>
      )}
    </div>
  );
};

export default TeamMemberSelector;
